<template>
  <el-select
    v-if="groups.length"
    :value="value"
    size="small"
    clearable
    :filterable="manyStores"
    :placeholder="$t('가게')"
    class="shop-select"
    data-testid="delivery-shop-select"
    @change="onChange">
    <el-option-group v-for="group in groups" :key="group.platform" :label="group.label">
      <el-option v-for="option in group.options" :key="option.id" :label="option.label" :value="option.value">
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { chosenShop, shopKey, shopOptionGroups, spansStores } from '@/utils/deliveryShops'

/**
 * 배달 매출의 **가게 칸** — 배달 매출 관리·거래 상세가 함께 쓴다. 선택지·라벨·여러 매장 판정은 `utils/deliveryShops`.
 *
 * 값은 부모의 `platform`·`shopNo`(조회 조건 그대로)이고 `.sync` 로 돌려준다: 가게를 고르면 플랫폼도 그 가게의 앱으로
 * 맞추고, 비우면 가게만 비운다. 선택지가 없으면(N:1 매장 없음) 칸을 그리지 않는다.
 */
export default {
  props: {
    shops: { type: Array, default: () => [] },
    platform: { type: String, default: '' },
    shopNo: { type: String, default: '' },
  },
  computed: {
    groups() {
      return shopOptionGroups(this.shops, { platform: this.platform, shopNo: this.shopNo })
    },
    manyStores() {
      return spansStores(this.shops)
    },
    value() {
      return shopKey(this.platform, this.shopNo)
    },
  },
  methods: {
    onChange(value) {
      const shop = chosenShop(this.groups, value)
      if (shop) this.$emit('update:platform', shop.platform)
      this.$emit('update:shopNo', shop ? shop.shopNo : '')
    },
  },
}
</script>

<style scoped>
.shop-select {
  width: 180px;
}
</style>
